module.exports = "/_next/static/images/0bfdde862cda939bac8aad37dfa610aa-roxinho-basicos-flutuantes-lg@2x.png.webp";